export default __webpack_public_path__ + "static/media/checkIconFill.2346d105.svg";